export default {
	title: "Usuários",
	email: "E-mail",
	displayName: "Nome",
	ritualFunction: "Função Ritual",
	role: "Papel",
	createdAt: "Criado em",
	totalUsers: "Total de usuários",
	ownerUsers: "Proprietários",
	adminUsers: "Administradores",
	memberUsers: "Membros",
	inviteUser: "Convidar Usuário",
	confirmRemove: "Confirmar Remoção",
	confirmRemoveMessage: "Tem certeza que deseja remover {name} do templo?",
	removeSuccess: "Usuário removido com sucesso",
	removeError: "Erro ao remover usuário",
	roleChangeSuccess: "Papel atualizado com sucesso",
	roleChangeError: "Erro ao alterar papel",
};
